import React from 'react';
import { Link } from 'react-router-dom';

const LOGO_SRC = 'https://assets.auxodev.dk/assets/73686664-eff4-4605-b977-e635729d5a69/skat-log.png';
const LOGO_OPTIMIZED_LG = 'https://assets.auxodev.dk/cdn-cgi/image/width=640,quality=95,format=auto/assets/73686664-eff4-4605-b977-e635729d5a69/skat-log.png';
const LOGO_OPTIMIZED_MD = 'https://assets.auxodev.dk/cdn-cgi/image/width=400,quality=95,format=auto/assets/73686664-eff4-4605-b977-e635729d5a69/skat-log.png';
const LOGO_OPTIMIZED_SM = 'https://assets.auxodev.dk/cdn-cgi/image/width=280,quality=95,format=auto/assets/73686664-eff4-4605-b977-e635729d5a69/skat-log.png';

export default function Logo({ variant = 'masthead', className = '', showTagline = true }) {
  if (variant === 'compact') {
    return (
      <Link
        to="/"
        className={`group inline-flex items-center gap-2 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#fd7302] ${className}`}
        aria-label="Skatunderlup Forside"
      >
        <img
          src={LOGO_OPTIMIZED_SM}
          alt="Skatunderlup"
          className="h-8 sm:h-9 w-auto object-contain transition-transform duration-150 group-hover:scale-[1.02]"
        />
      </Link>
    );
  }

  if (variant === 'footer') {
    return (
      <Link
        to="/"
        className={`group inline-flex flex-col items-start focus:outline-none focus-visible:ring-2 focus-visible:ring-[#fd7302] ${className}`}
        aria-label="Skatunderlup Forside"
      >
        <div className="inline-block bg-white px-3.5 py-2 rounded-sm border border-slate-700 shadow-xs transition-transform duration-150 group-hover:scale-[1.02]">
          <img
            src={LOGO_OPTIMIZED_MD}
            alt="Skatunderlup"
            className="h-8 sm:h-9 w-auto object-contain"
          />
        </div>
        <span className="mt-2.5 text-[10px] font-semibold tracking-[0.2em] text-slate-400 uppercase">
          Uafhængig digital fagavis for skat & afgifter
        </span>
      </Link>
    );
  }

  // Default: Full Editorial Masthead for newspaper header
  return (
    <Link
      to="/"
      className={`group flex flex-col items-center justify-center text-center focus:outline-none focus-visible:ring-2 focus-visible:ring-[#fd7302] ${className}`}
      aria-label="Skatunderlup Forside"
    >
      <div className="relative inline-flex items-center justify-center py-1 sm:py-1.5">
        <img
          src={LOGO_OPTIMIZED_LG}
          srcSet={`${LOGO_OPTIMIZED_SM} 280w, ${LOGO_OPTIMIZED_MD} 400w, ${LOGO_OPTIMIZED_LG} 640w`}
          sizes="(max-width: 640px) 240px, (max-width: 1024px) 320px, 380px"
          alt="Skatunderlup"
          className="h-12 sm:h-16 md:h-20 w-auto max-w-[260px] sm:max-w-[340px] md:max-w-[400px] object-contain transition-transform duration-200 group-hover:scale-[1.01]"
          loading="eager"
        />
      </div>
      {showTagline && (
        <div className="mt-1 flex items-center justify-center gap-2 text-[10px] sm:text-[11px] font-medium tracking-[0.22em] uppercase text-slate-500">
          <span className="hidden sm:inline-block h-px w-6 sm:w-10 bg-slate-200" />
          <span>Uafhængigt redaktionelt fagmedie for skat, moms og afgifter</span>
          <span className="hidden sm:inline-block h-px w-6 sm:w-10 bg-slate-200" />
        </div>
      )}
    </Link>
  );
}
